import React from 'react'

const highlights = {
    id: '2018-highlights',
    type: 'post',
    countryId: 'seAsia',
    title: 'Highlights from an Amazing 2018',
    longDate: 'December 31, 2018',
    month: 'Dec',
    date: '31',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/highlightscover.jpg',
    content: [
        {
            text: (
                <div>2018 has been a truly incredible year for us, and we're so happy we took the leap to spend time exploring the world (especially because that leap was really scary!) On New Year's Eve, we went to Chiang Mai's lantern festival, where thousands of people gather to light up lanterns like hot air balloons and release them into the sky. With the lantern, you release negative things from the last year – expectations, failures, toxicity. Then, you look forward to the new year.</div>
            )
        },
        {
            text: (
                <div>We were feeling reflective and went through our past year, reviewing our favorite moments. Some are travel adventures, and many are moments with friends and family. Here are our highlights from 2018.</div>
            )
        },
        {
            header: 'January'
        },
        {
            text: (
                <div>In January, we started off the year in Portland, still on Christmas break, playing with my mom's new puppy Henry. I insisted on a fancy, dress-up birthday party, and celebrated with friends, champagne, and dancing at Press Club.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/Henry.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/Henry2.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/BirthdayParty.jpg'
        },
        {
            header: 'February'
        },
        {
            text: (
                <div>In February, I told Salesforce I was leaving and got a wonderfully enthusiastic response. (Peter still hadn't told Superhuman yet.) I stayed at the Ritz Carlton Half Moon Bay on a work trip and felt very fancy. We went on our annual ski trip to Montana, which our friend Ben hosts and organizes, and there were some shenanigans involving drinking games and dancing on coffee tables. On the way, we stopped over in Seattle to see Mary and David and discovered Peter's favorite bar, Barnacle (an amaro bar.)</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/HalfMoonBay.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/Montana1.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/Montana2.jpg'
        },
        {
            header: 'March'
        },
        {
            text: (
                <div>In March, Peter went on a skip trip to Tahoe with friends Natt and Jacklyn where he tried cross-country skiing for the first time in years, and discovered he really likes it! He has been trying to convince me to try it ever since. Both sets of parents and my sister came to California, and we did a weekend in wine country together.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/Fam.jpg'
        },
        {
            header: 'April'
        },
        {
            text: (
                <div>In April, we went to Peru with my mom and sister, and incredible trip. Our highlight was on the day we went to <a href="https://worldofwander.app/post/planning-machu-picchu">Machu Picchu</a>: as we started the Huyana Picchu hike to get a view of the main ruins, we saw a sign for a smaller peak, Huchu'y Picchu, and a path that no one was on. We went to the top and had the views of Machu Picchu all to ourselves. Also, we went to New Orleans for a Sigma Chi wedding, had a blast, and fell in love with the brunch at Cane and Table.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/MP.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/MP2.jpg'
        },
        {
            header: 'May'
        },
        {
            text: (
                <div>In May, we invited every friend we'd made in San Francisco to our empty apartment for a going away party, and pissed off the neighbors across the street with the noise. That's a sign of a successful going away party. (No photos exist from this night.) We also went to Rhode Island for Kevin and Ashley's wedding, and took the groom out to a club the night before the big event. On May 29, we took a one-way flight to England.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/Kevin.jpg'
        },
        {
            header: 'June'
        },
        {
            text: (
                <div>In June, we started off with family time and Peter's cousin's wedding in the north of England (congrats, Laura and Olly!), then tried out our new backpacks <a href="https://worldofwander.app/post/lake-district">hiking in the Lake District</a> – the highlight of which was Striding Edge. We then went to our favorite country, <a href="https://worldofwander.app/photoPost/best-photos-iceland">Iceland</a>, for three weeks, and loved living in a camper van. A huge highlight was the end of our first semi-terrible day on the <a href="https://worldofwander.app/post/laugavegur">Laugavegur trek</a>, when made it through a snowstorm and caught the first glimpse of our warm hut. Another was our <a href="https://worldofwander.app/post/hot-pots-of-iceland">hot waterfall</a> adventure day, which included meeting an over-excited husky and getting a lift from a burly man driving a crazy jeep through a river.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/StridingEdge.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/trek.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/waterfall.jpg'
        },
        {
            header: 'July'
        },
        {
            text: (
                <div>In July, we got back from Iceland and spent more time with both Peter's family in Sussex and friends in London, including a day of sunshine and Pimm's at the Henley regatta. We <a href="https://worldofwander.app/post/sailing-england">went sailing</a> with Peter's parents and saw gorgeous sunsets over the Channel. And we hiked 100 miles over 10 days on the <a href="https://worldofwander.app/post/hiking-tour-du-mont-blanc">Tour du Mont Blanc</a>, the highlight of which was eating a massive bowl of spaghetti carbonara at the top of a mountain on day 2.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/Henley.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/Sailing.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/TMB.jpg'
        },
        {
            header: 'August'
        },
        {
            text: (
                <div>In August, we made our way from Geneva to the south of France and spent a glorious week lying around in the sun, and wined and dined in the cobblestoned streets of St. Emilion with Ranee and Aaron. Then it was back to America to explore the Pacific Northwest and get a lot of relax time in at my mom's house.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/France.jpg'
        },
        {
            header: 'September'
        },
        {
            text: (
                <div>In September, we drove up to <a href="https://worldofwander.app/post/seattle-olympic-peninsula">Seattle</a> with my mom's trailer, spent a week camping in Olympic National Park, and capped it off with an awesome Labor Day weekend at an Airbnb on the Sound. We stayed with Mary and David again in Seattle and fell in love with the city. We discovered new locations of McMenamins and spent lots of time at the outdoor bars and pools in Seattle, Bend, and Portland – and after a beer festival there, spontaneously went to a Portland Timbers Game with friends of friends of my cousin Katie.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/WA1.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/WA2.jpg'
        },
        {
            header: 'October'
        },
        {
            text: (
                <div>In October, we took a one-way flight to <a href="https://worldofwander.app/post/first-24-hours-vietnam">Vietnam</a> and started the Southeast Asia portion of our travels! In <a href="https://worldofwander.app/photoPost/hanoi-highlights">Hanoi</a>, we took a terrifying bicycle tour of the city during rush hour and followed it that evening with a redeeming and delicious <a href="https://worldofwander.app/photoPost/hanoi-street-food">street food</a> tour. We took an overnight trip to <a href="https://worldofwander.app/post/ninh-binh">Tam Coc</a> and watched the sunset from Mua Caves. Our favorite part of Cao Bang was not the expected Ban Gioc waterfall, but just motorbiking around the mountains surrounding the city. And when we got to Saigon, we went to a Halloween trivia night with new friends and WON! (Peter and I contributed very little to the actual trivia, but we were the fastest couple to spin your partner into a mummy with toilet paper and take a tequila shot.)</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/streetfood.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/CB.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/mua.jpg'
        },
        {
            header: 'November'
        },
        {
            text: (
                <div>In November we found an apartment to make our home in Saigon, and took a short trip to <a href="https://worldofwander.app/post/mui-ne">Mui Ne</a>, where we discovered the world's best Eggs Benedict. We escaped the city and went to the idyllic Thai islands, where we took in sunset on <a href="https://worldofwander.app/post/koh-yao">Koh Yao Noi</a> from a tiny beachside shack called the Gypsy Bar and survived a rainstorm by hiding out to eat and drink at Rice Terrace Restaurant on Koh Yao Yai. And on <a href="https://worldofwander.app/post/koh-lanta">Koh Lanta</a>, we did an awesome cave tour that quickly turned into terror for me when I saw the size of cave spiders.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/kyy.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/rice.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/cave.jpg'
        },
        {
            header: 'December'
        },
        {
            text: (
                <div>In December, we met up with new friends and spent an entire afternoon and evening progressing from beer festival to happy hour to street food (oh, those mini banh xeos!) to Bui Vien backpacker's district. In <a href="https://worldofwander.app/post/dalat">Dalat</a>, we sat through the rain at a public square to watch Vietnam win the AFF Cup regional finals. Our friends Fiona and Aaron came to Saigon, and we went together to Bangkok, where we had some truly excellent food and drinks and were enchanted by DJ Bear. We closed out the year with the lantern festival on New Year's Eve in Chiang Mai.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/bangkok.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/2018-highlights/lantern.jpg'
        },
        {
            text: (
                <div>It's been a magical year, and we can't wait for more adventures in 2019.</div>
            )
        },
]
}

export default highlights


// WEBPACK FOOTER //
// ./src/Posts/Content/highlights.js